import { WorkspaceHomeCTAsSection } from "../components/sections/WorkspaceHomeCTAsSection"
import { WorkspaceHomeGetMoreSection } from "../components/sections/WorkspaceHomeGetMoreSection"
import { WorkspaceHomeLearnSection } from "../components/sections/WorkspaceHomeLearnSection"

export const WorkspaceHomeBodyNewUser = () => {
    return (
        <>
            {/* Primary CTAs */}
            <WorkspaceHomeCTAsSection />

            <div className="flex flex-col xl:flex-row gap-0 xl:gap-12">
                {/* Secondary/Learn Section */}
                <WorkspaceHomeLearnSection style={{ flex: "1 1" }} />

                {/* Tertiary / Get More Section */}
                <WorkspaceHomeGetMoreSection
                    style={{ flex: "1 0.33" }}
                    className="mb-12 xl:mb-0"
                    isFirstLogin
                />
            </div>
        </>
    )
}
